import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import Slider from "@material-ui/core/Slider";
import Rating from "@material-ui/lab/Rating";
import TokenPool from "../components/SearchTokenPools/TokenPool";
import Table from "../components/Misc/Table";
import DonutChart from "../components/Misc/DonutChart";

import Doughnut from "../assets/Doughnut.png";
import { useDispatch, useSelector } from "react-redux";
import { getTableData } from "../redux/actions/web3Actions";

import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import LineTable from "../components/Misc/LineTable";
// import TokenPool from "../components/SearchTokenPools/TokenPool";
// import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 200,
  },
  StepContainer: {
    background: "#FFFFFF",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",
    padding: "1.5rem",
    height: "13rem",

    flexWrap: "wrap",
  },
  pieBox: {
    marginTop: "2rem",
    // padding: "0px 1rem",
    // display: "flex",
    // justifyContent: "space-between",
  },
  list: {
    alignItems: "center",
    margin: "3rem 1rem 0px 1rem",
  },
  table: {
    border: "1px solid pink",
    margin: "2rem 0px",
    width: "50%",
    height: "100%",
    // alignItems: "center",
  },
  BigCard: {
    background: "#FFFFFF",
    marginTop: "2rem",
    borderRadius: "8px",
    marginRight: "1rem",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",
    borderRadius: "8px",

    padding: "1.5rem",
    width: "45%",
    minWidth: "35rem",
    // height: "30rem",
  },
  head: {
    height: "4rem",
    backgroundColor: "rgba(246, 48, 169, 0.1)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // textAlign: "center",
    padding: "0px 1rem",
  },
  Card3: {
    width: "100%",
    backgroundColor: "white",
    padding: "2.5rem",
    borderRadius: "8px",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",

    height: "30rem",
    marginTop: "3rem",
  },
  headingText: {
    fontWeight: "600",
    // flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2.4rem",
    lineHeight: "3rem",
    marginBottom: "1rem",
    marginLeft: "1rem",
  },
  dot: {
    backgroundColor: ({ color }) => color,

    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  pinkDot: {
    backgroundColor: "#f630a9",
    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },
  container: {
    padding: "1rem",
    maxWidth: "1200px",
  },
  percentage: {
    fontSize: "3.5rem",
    fontWeight: "700",
    margin: "1rem 1rem 0rem 0rem",
  },
  grid: {
    display: "flex",
    // alignItems: "center",
    justifyContent: "space-between",
  },
  grid2: {
    display: "flex",
    alignItems: "center",
    marginTop: "1.4rem",
  },
  capBold: {
    fontSize: "1.4rem",
    fontWeight: "700",
  },
  bodyText: {
    // fontWeight: "600",
    // flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flex3: {
    display: "flex",
    alignItems: "center",
    padding: "0.5rem 0rem",
  },
  row: {
    display: "flex",
    height: "4.3rem",
    alignContent: "center",
    borderBottom: "1px solid rgba(246, 48, 169, 0.2)",
    // backgroundColor: "aqua",
    padding: "0px 1rem",
    justifyContent: "space-between",
  },
  stars: {
    marginLeft: "12rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "space-around",
    flex: 1,
    height: "100%",
    padding: "1rem 0px",
    marginBottom: "2rem",
    // backgroundColor: "red",
  },
  star: {
    flex: 1,
    // backgroundColor: "yellow",
    display: "flex",
    justifyContent: "space-around",
  },
  flex: {
    display: "flex",
    marginBottom: "2rem",
    // justifyContent:"space-between"
    // alignItems: "center",
  },
  flex2: {
    display: "flex",
    // background:"red",
    width: "50%",
    // marginBottom: "2rem",
    // alignItems: "center",
  },
  card: {
    background: "white",
    padding: "1rem 2rem",
    width: "100%",
    borderRadius: "8px",
  },
  bold: {
    fontWeight: "600",
    fontSize: "1.3rem",
  },
  barColor: {
    backgroundColor: "#F630A9",
  },
  barRoot: {
    height: "1.2rem",
    borderRadius: "8px",
  },
  track: {
    backgroundColor: "#F630A9",
    // width: "2rem",
  },
  rail: {
    backgroundColor: "#F630A9",
    // height: "1rem",
    // width: "7rem",
  },
  thumb: {
    color: "#F630A9",
    width: "1.3rem",
    height: "1.3rem",
  },
}));

const Dot = (color) => {
  const classes = useStyles(color);

  return <Box className={classes.dot}></Box>;
};

const SearchTokenPools = () => {
  const MyTypography = ({ children }) => {
    return (
      <Typography style={{ fontSize: "1rem", textAlign: "center" }}>
        {" "}
        {children}
      </Typography>
    );
  };

  function LinearProgressWithLabel(props) {
    return (
      <Box display="flex" alignItems="center" style={{ margin: "2rem 2rem" }}>
        <Box minWidth={40}>
          <MyTypography>5 Stars</MyTypography>
        </Box>
        <Box width="100%" mr={1} ml={1}>
          <LinearProgress
            variant="determinate"
            value={props.value}
            style={{ backgroundColor: "rgba(246, 48, 169, 0.15)" }}
            classes={{ bar: classes.barColor, root: classes.barRoot }}
          />
        </Box>
        <Box minWidth={35}>
          <MyTypography>{`${Math.round(props.value)}%`}</MyTypography>
        </Box>
      </Box>
    );
  }
  const classes = useStyles();

  const value = 4;

  function valuetext(value) {
    return `${value}°C`;
  }
  function valueLabelFormat(value) {
    return marks.findIndex((mark) => mark.value === value) + 1;
  }
  const [totalInvested, setTotalInvested] = useState(0);
  const [outstandingTokens, setOutstandingTokens] = useState(0);

  const Theading = ["Project Name", "Token Amount", "Status", " "];

  const heading = [
    "Months",
    // "Number of Projects ",
    "Invested",
    "Work Outstanding",
    "Token Amount",
    "Token Outstanding",
  ];

  const marks = [
    {
      value: 100,
      label: "5 star/ 5",
    },
    {
      value: 80,
      label: "4 star/ 5",
    },
    {
      value: 60,
      label: "3 star/ 5",
    },
    {
      value: 40,
      label: "2 star/ 5",
    },
    {
      value: 20,
      label: "1 star/ 5",
    },
  ];
  const dispatch = useDispatch();

  const isUser = useSelector((state) => state.ui.isUser);
  const tableData = useSelector((state) => state.ui.tableData);

  useEffect(() => {
    if (isUser?.kol?._id) {
      dispatch(getTableData(isUser?.kol?._id));
    }
  }, [isUser]);

  useEffect(() => {
    if (tableData) {
      const finalSum = tableData.reduce((initialSum, item) => {
        return item.invested + initialSum;
      }, 0);

      // console.log({ finalSum }); // 6
      setTotalInvested(finalSum);

      const finalSumToken = tableData.reduce((initialSum, item) => {
        return item.tokenOutstanding + initialSum;
      }, 0);

      setOutstandingTokens(finalSumToken);
    }
  }, [tableData]);
  return (
    <>
      <Box className={classes.container}>
        <Grid container className={classes.card}>
          <Grid className={classes.subGrid}>
            <Typography
              style={{ margin: "2rem 0rem" }}
              className={classes.capBold}
            >
              Invested Pools (Total) : {tableData?.length}
            </Typography>
            <Typography>Total</Typography>

            <Typography className={classes.capBold}>
              {totalInvested - outstandingTokens} USDT / {totalInvested} USDT
            </Typography>
            <Box className={classes.flex}>
              <Box>
                <Box className={classes.grid2}>
                  <Box className={classes.dot}></Box>
                  <Typography> Recieved </Typography>
                </Box>
                <Typography
                  style={{ marginLeft: "1rem" }}
                  className={classes.bold}
                >
                  {totalInvested - outstandingTokens}USDT
                </Typography>
              </Box>

              <Box style={{ marginLeft: "9.3rem" }}>
                <Box className={classes.grid2}>
                  <Box className={classes.pinkDot}></Box>
                  <Typography> Outstanding </Typography>
                </Box>
                <Typography
                  style={{ marginLeft: "1rem" }}
                  className={classes.bold}
                >
                  {outstandingTokens} USDT
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid className={classes.subGrid}>
            {/* <Typography>Invested Poossssssssssssssssssssssssssssssssssssssssssssls (Total)</Typography> */}
          </Grid>
        </Grid>

        <Box className={classes.grid}>
          <Box className={classes.BigCard}>
            <Typography className={classes.bold}>Outstanding Tokens</Typography>

            <Box className={classes.pieBox}>
              <DonutChart tableData={tableData} />
            </Box>
          </Box>

          <Box className={classes.BigCard}>
            <Typography className={classes.bold}>Posts Outstanding</Typography>
            <Box className={classes.pieBox}>
              <DonutChart tableData={tableData} />
            </Box>
          </Box>
        </Box>
        {/* <Table title="Claimable tokens" Theading={Theading} /> */}
        <LineTable title="Token Pools (month)" heading={heading} />

        <Box className={classes.card}>
          <Typography className={classes.capBold}>Ranking Overview</Typography>
          <Box className={classes.flex}>
            <Box className={classes.table}>
              <Box className={classes.head}>
                <Typography className={classes.headingText}>Month</Typography>
                <Typography className={classes.headingText}>
                  Ranking Score
                </Typography>
              </Box>
              {/* <Box className={classes.row}>
                <Typography className={classes.bodyText}>Previous</Typography>
                <Typography className={classes.bodyText}>150/500</Typography>
              </Box> */}
              <Box className={classes.row}>
                <Typography className={classes.bodyText}>Current</Typography>
                <Typography className={classes.bodyText}>
                  {isUser?.rating}/5
                </Typography>
              </Box>
            </Box>

            <Box className={classes.flex2}>
              <Box style={{ width: "100%" }} className={classes.root}>
                <Slider
                  style={{ margin: "2rem 0rem 0rem 6rem ", height: "90%" }}
                  classes={{
                    track: classes.track,
                    rail: classes.rail,
                    thumb: classes.thumb,
                  }}
                  orientation="vertical"
                  step={null}
                  value={isUser?.rating * 20}
                  // defaultValue={isUser?.rating * 20 || 60 }
                  // defaultValue={0}
                  disabled
                  //   valueLabelFormat={valueLabelFormat}
                  marks={marks}
                />
              </Box>
              {console.log("RATE==========", isUser?.rating * 20)}
              <Box style={{ width: "100%" }} className={classes.stars}>
                <Rating
                  className={classes.star}
                  size="large"
                  name="read-only"
                  value={5}
                  readOnly
                />
                <Rating
                  className={classes.star}
                  size="large"
                  name="read-only"
                  value={4}
                  readOnly
                />

                <Rating
                  className={classes.star}
                  size="large"
                  name="read-only"
                  value={3}
                  readOnly
                />

                <Rating
                  className={classes.star}
                  size="large"
                  name="read-only"
                  value={2}
                  readOnly
                />

                <Rating
                  className={classes.star}
                  size="large"
                  name="read-only"
                  value={1}
                  readOnly
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SearchTokenPools;
